import React, { useContext } from 'react';
import { Outlet, Link } from 'react-router-dom';
import { Navbar, Container, Nav, NavDropdown } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import usePermissions, { PERMISSIONS } from '../hooks/usePermissions';
import Jdenticon from 'react-jdenticon';
import AuthContext from '../context/AuthContext';
import { BsGlobe } from 'react-icons/bs';
import { useTranslation } from 'react-i18next'; // Importar useTranslation
import AppNavbar from './AppNavbar';

import ActivationBanner from './ActivationBanner';
import RenewalBanner from './RenewalBanner';
import EmailVerificationBanner from './EmailVerificationBanner';
import OnboardingTour from './OnboardingTour';

const Layout = () => {
    const { user, logoutUser, businessSettings } = useContext(AuthContext);
    const { hasPermission } = usePermissions(user);
    const { t, i18n } = useTranslation(); // Usar el hook de traducción y obtener 't' y 'i18n'

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    // Un solo banner a la vez. La verificación de correo tiene prioridad: mientras no esté
    // verificado, el paso "Suscripción" de ActivationBanner sería engañoso (el backend lo
    // bloquea igual, ver requireVerifiedEmail), así que no tiene sentido mostrarlo todavía.
    const needsEmailVerification = user && !user.email_verified_at;

    return (
        <>
            <AppNavbar />
            {needsEmailVerification ? (
                <EmailVerificationBanner />
            ) : (
                <>
                    <ActivationBanner />
                    <RenewalBanner />
                </>
            )}
            <OnboardingTour />
            <Outlet /> {/* This is where child routes will be rendered */}
        </>
    );
};

export default Layout;
